export default "__VITE_ASSET__Zkn8LwEP__"